module.exports = __webpack_public_path__ + "img/109.b8196749.jpg";